import {
  BuildingBank16Regular,
  BuildingBank24Regular,
  Camera16Regular,
  Camera24Regular,
  Cart16Regular,
  Cart24Regular,
  Image16Regular,
  Image24Regular,
  Megaphone16Regular,
  Megaphone24Regular,
  MusicNote216Regular,
  MusicNote224Regular,
  Payment16Regular,
  Payment24Regular,
  Phone16Regular,
  Phone24Regular,
  Video16Regular,
  Video24Regular,
  Wallet16Regular,
  Wallet24Regular,
} from '@/components/Icon'

export const workspaceIconPackD = {
  phone: { 16: Phone16Regular, 24: Phone24Regular },
  camera: { 16: Camera16Regular, 24: Camera24Regular },
  image: { 16: Image16Regular, 24: Image24Regular },
  video: { 16: Video16Regular, 24: Video24Regular },
  music: { 16: MusicNote216Regular, 24: MusicNote224Regular },
  megaphone: { 16: Megaphone16Regular, 24: Megaphone24Regular },
  cart: { 16: Cart16Regular, 24: Cart24Regular },
  payment: { 16: Payment16Regular, 24: Payment24Regular },
  wallet: { 16: Wallet16Regular, 24: Wallet24Regular },
  bank: { 16: BuildingBank16Regular, 24: BuildingBank24Regular },
}
